import type { ReactElement } from 'react';
import { toast } from 'react-toastify';

import type { IconVariant } from '../icons/icon';

import { Snackbar } from './snackbar';

import './main.css';

export const notify = ({
  icon,
  message,
  variant = 'default',
  withIcon = false,
}: {
  icon?: IconVariant;
  message: string | ReactElement;
  variant?: 'default' | 'error';
  withIcon?: boolean;
}) => {
  const autoClose = 5000;

  return toast(<Snackbar message={message} withIcon={withIcon} icon={icon} />, {
    autoClose,
    closeButton: false,
    closeOnClick: true,
    draggable: false,
    hideProgressBar: true,
    position: 'bottom-center',
    ...(variant === 'error' ? { type: 'error' as const } : {}),
  });
};
